import React, { useRef, useState } from 'react';
import Slider from 'react-slick';
import ContentsListItem from '@components/common/contentsListItem';
import SliderButton from '@components/common/sliderButton';
import { accaCenterDefaultPage, useAccCenterScreeningPassReviews } from '@repository/acc';
import { PostJobCardVO } from '@domain/vo/postJob/PostJobCardVO';
import { V2Route } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './accaReviewList.module.scss';
const cx = classnames.bind(styles);

const PrevArrow = (props: any) => {
  const { className, style, onClick } = props;

  return (
    <SliderButton
      type={'prev'}
      slickClass={className}
      handleClick={onClick}
      style={{ ...style }}
      customClassName={cx('btnPrev')}
    />
  );
};

const NextArrow = (props: any) => {
  const { className, style, onClick } = props;

  return (
    <SliderButton
      type={'next'}
      slickClass={className}
      handleClick={onClick}
      style={{ ...style }}
      customClassName={cx('btnNext')}
    />
  );
};

const AccaReviewList = () => {
  const dragging = useRef(false);
  const { data, fetchNextPage, hasNextPage } = useAccCenterScreeningPassReviews();
  const isNotReview = data?.pages[0] && data?.pages[0].posts.length < 1;

  const acaaReviewListItems = data?.pages.map(({ posts }) => {
    return posts.map((post: PostJobCardVO) => (
      <div className={cx('listItemWrap')} key={post.sn}>
        <ContentsListItem
          contentData={{
            ...post,
            name: post.categoryName,
            tag: post.label,
            routeUrl: V2Route.getInfoDetailPage(post.sn),
          }}
          handleDrag={() => !dragging.current}
        />
      </div>
    ));
  });

  const settings = {
    infinite: false,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    slidesToShow: 4,
    slidesToScroll: 2,
    speed: 300,
    cssEase: 'ease-in-out',
    draggable: true,
    beforeChange: () => (dragging.current = true),
    afterChange: () => {
      if (hasNextPage) fetchNextPage();
      dragging.current = false;
    },
  };

  if (isNotReview) return null;

  return (
    <div className={cx('accaReviewListArea')}>
      <strong className={cx('sectionTitle')}>역검 합격 후기 모음</strong>

      <div className={cx('accaReviewListInner')}>
        <Slider {...settings}>{acaaReviewListItems}</Slider>
      </div>
    </div>
  );
};

export default AccaReviewList;
